import {connect} from "react-redux";
import RankingTooltipTrigger from "./RankingTooltipTrigger.jsx";
import {tooltipsHideAction, tooltipsShowAction} from "./rankingTooltipsActions";

const RankingTooltipTriggerContainer = connect(
    null,
    (dispatch) => ({
        onShow: () => dispatch(tooltipsShowAction()),
        onHide: () => dispatch(tooltipsHideAction()),
    })
)(RankingTooltipTrigger);

export default RankingTooltipTriggerContainer